export default __webpack_public_path__ + "static/media/03final.8b0df6ee.png";